import { UnitTypeEnum } from 'enums/UnitTypeEnum';

export const getReadableUnitByName = (unit: string): string => {
  if (unit === UnitTypeEnum.UNDEFINED) return '';
  return UnitTypeEnum[unit as keyof typeof UnitTypeEnum];
};

export const parseUnitType = (unit?: string): string => {
  if (!unit) return '';
  if (unit === 'm3') return 'm³';
  if (unit === 'percentage') return '%';
  if (unit === 'degrees_celsius') return '°C';
  if (unit === 'hectopascal') return 'hPa';
  if (unit === 'ppm') return 'ppm';
  if (unit === 'kWh') return 'kWh';
  if (unit === 'm³') return 'm³';
  if (unit === 'l') return 'l';
  return unit;
};
